<template>
  <div class="task-table">
    <div class="task-List-container" ref="containerRef">
      <div class="task-blank" v-show="state.taskList.length === 0">
        <div class="pic"></div>
        <p>暂无任务进行</p>
      </div>
      <a-table
        v-show="state.taskList.length !== 0"
        :columns="columns"
        :data-source="state.taskList"
        :row-key="record => record.taskKey"
        :pagination="{
          total: state.taskList.length,
          defaultPageSize: 8,
        }"
        :customRow="customRow"
      >
        <template #fileName="{ text, index }">
          <span> {{ text.slice(0, text.length - 4) }} </span>
          <span v-show="currentEnter === index" :ref="setItemRef" class="showDeleteTips">
            音频文件或字幕文件已被删除
          </span>
        </template>
        <template #langType="{ text }">
          {{ text === 'en' ? '英文' : '中文' }}
        </template>
        <template #duration="{ text }">
          {{ durationFormat(Number(text)) }}
        </template>
        <template #createTime="{ text }">
          <div class="createTimeBox">
            {{ timeFormat(Number(text)) }}
          </div>
        </template>
        <template #status="{ text, record }">
          <div class="status">
            <div v-if="text === 0" class="pending">
              进行中
              <span>
                <img src="../imgs/pending.png" class="pendingLoading" />
              </span>
            </div>
            <div
              v-else-if="text === 1"
              :class="
                record.articleStatus !== 1 || record.lrcStatus !== 1
                  ? 'fulfilled-mask'
                  : 'fulfilled'
              "
            >
              已完成
            </div>
            <div v-else class="failed">字幕生成失败</div>
          </div>
        </template>
        <template #operation="{ text, record }">
          <div class="operationBox" ref="operationRef">
            <span
              v-if="record.status === 1 && record.articleStatus === 1 && record.lrcStatus === 1"
              class="edit"
              data-rlog="list_edit_click"
              @click="editTask(record.articleKey, record.columnKey, record.langType)"
            >
              {{ text[0] }}
            </span>
            <span v-else class="edit-disabled">
              {{ text[0] }}
            </span>
            <span
              class="delete"
              data-rlog="list_delete_click"
              ref="deleteIconRef"
              @click="showConfirmModal(record.taskKey, record.articleStatus, record.lrcStatus)"
            >
              {{ text[1] }}
            </span>
          </div>
        </template>
      </a-table>
    </div>
  </div>
  <ConfirmModal
    rlogKey="list_delete_click"
    @confirm="deleteTask"
    ref="deleteTaskRef"
    title="删除任务记录"
    contentTxt="是否要删除该条任务记录"
  ></ConfirmModal>
  <ConfirmModal
    rlogKey="list_delete_click"
    @confirm="deleteTask"
    ref="deleteNormalTaskRef"
    title="删除任务记录"
    contentTxt="是否要删除任务？删除任务后生成的字幕文件不会被删除"
  ></ConfirmModal>
</template>
<script>
import { useRouter } from 'vue-router';
import { reactive, ref, computed, onMounted, watch, onUpdated } from 'vue';
import { message } from 'ant-design-vue';
import { requestTaskList, deleteHearingTask } from '../methods/HearingTaskList';
import ConfirmModal from '../../../components/common/ConfirmModal.vue';

export default {
  components: {
    ConfirmModal,
  },
  props: {
    queryTaskType: {
      type: String,
      default: 'all',
    },
  },
  emits: ['pendingNumChanged'],
  setup(props, context) {
    const deleteTaskRef = ref(null);
    const deleteNormalTaskRef = ref(null);
    const route = useRouter();
    const deleteTaskKey = ref('');
    const articleKey = ref('');
    const columnKey = ref('');
    const pendingNum = ref(0);
    const timer0 = ref(null);
    const isShowDeleteTips = ref(false);
    const currentEnter = ref(-1);
    const containerRef = ref(null);
    let itemRefs = [];
    const deleteIconRef = ref(null);
    const operationRef = ref(null);

    const setItemRef = el => {
      if (el) {
        itemRefs.push(el);
      }
    };

    const columns = ref([
      {
        title: '文件名',
        dataIndex: 'title',
        key: 'title',
        slots: { customRender: 'fileName' },
      },
      {
        title: '文件语言',
        dataIndex: 'langType',
        key: 'langType',
        slots: { customRender: 'langType' },
      },
      {
        title: '时长',
        dataIndex: 'duration',
        key: 'duration',
        slots: { customRender: 'duration' },
      },
      {
        title: '创建日期',
        key: 'createTime',
        dataIndex: 'createTime',
        slots: { customRender: 'createTime' },
      },
      {
        title: '任务状态',
        key: 'status',
        dataIndex: 'status',
        slots: { customRender: 'status' },
      },
      {
        title: '操作',
        key: 'operation',
        dataIndex: 'operation',
        slots: { customRender: 'operation' },
        width: '156px',
        align: 'center',
      },
    ]);
    const dataTest = ref([
      {
        createTime: 1624863234000,
        duration: 150,
        taskKey: '1', // 任务key
        title: '专辑test1.mp3',
        status: 0, // 0：进行中，1：完成，2：失败，3：删除
        langType: 'en',
        operation: ['编辑字幕', '删除'],
      },
      {
        createTime: 1624863234000,
        duration: 154,
        taskKey: '2', // 任务key
        title: '专辑test2.mp3',
        status: 1, // 0：进行中，1：完成，2：失败，3：删除
        langType: 'en',
        operation: ['编辑字幕', '删除'],
      },
      {
        createTime: 1624863234000,
        duration: 300,
        taskKey: '3', // 任务key
        title: '专辑test3.mp3',
        status: 2, // 0：进行中，1：完成，2：失败，3：删除
        langType: 'en',
        operation: ['编辑字幕', '删除'],
      },
    ]);
    const state = reactive({
      taskList: [],
    });
    const durationFormat = computed(
      () =>
        function formatDuration(num) {
          const h =
            Math.floor(num / 3600) < 10 ? `0${Math.floor(num / 3600)}` : Math.floor(num / 3600);
          const m =
            Math.floor((num % 3600) / 60) < 10
              ? `0${Math.floor((num % 3600) / 60)}`
              : Math.floor((num % 3600) / 60);
          const s =
            Math.floor((num % 3600) % 60) < 10
              ? `0${Math.floor((num % 3600) % 60)}`
              : Math.floor((num % 3600) % 60);
          return h !== '00' ? `${h}:${m}:${s}` : `${m}:${s}`;
        }
    );
    const timeFormat = computed(
      () =>
        function formatTime(number) {
          const date = new Date(number);
          const Y = date.getFullYear();
          const M = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
          const D = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
          return `${Y}-${M}-${D}`;
        }
    );

    async function displayTaskList() {
      const result = await requestTaskList({ type: props.queryTaskType });
      if (result.code !== 0) {
        deleteTaskRef.value.toggleModal(false);
        deleteNormalTaskRef.value.toggleModal(false);
        message.error({ content: result.msg });
        return;
      }
      state.taskList = result.data;
      state.taskList.forEach(currentValue => {
        // eslint-disable-next-line no-param-reassign
        currentValue.operation = ['编辑字幕', '删除任务'];
      });
      const pendingNumArray = state.taskList.filter(value => value.status === 0);
      pendingNum.value = pendingNumArray.length;
      if (pendingNum.value === 0) {
        clearInterval(timer0.value);
        timer0.value = null;
      }
    }
    onMounted(async () => {
      const messageLoading = message.loading({ content: 'loading', duration: 0 });
      await displayTaskList();
      messageLoading();
    });
    onUpdated(() => {
      itemRefs = [];
    });
    watch(
      () => props.queryTaskType,
      () => {
        displayTaskList();
      }
    );
    watch(pendingNum, newValue => {
      if (newValue !== 0) {
        clearInterval(timer0.value);
        timer0.value = setInterval(() => {
          displayTaskList();
        }, 1000);
      } else {
        clearInterval(timer0.value);
        timer0.value = null;
      }
      context.emit('pendingNumChanged', newValue);
    });

    function customRow(record, index) {
      if ((record.articleStatus !== 1 || record.lrcStatus !== 1) && record.status !== 0) {
        return {
          style: {
            color: '#DFDFE0 !important',
          },
          onMouseenter: () => {
            isShowDeleteTips.value = true;
            currentEnter.value = index;
          },
          onmousemove: e => {
            if (!containerRef.value || !deleteIconRef.value || !operationRef.value) return;
            let numPosition = e.pageX - 340;
            if (
              numPosition >
              containerRef.value.offsetWidth -
                deleteIconRef.value.offsetWidth -
                0.1 * operationRef.value.offsetWidth -
                itemRefs[index].offsetWidth -
                40
            ) {
              numPosition =
                containerRef.value.offsetWidth -
                deleteIconRef.value.offsetWidth -
                0.1 * operationRef.value.offsetWidth -
                itemRefs[index].offsetWidth -
                40;
            }
            const leftPosition = `${numPosition}px`;
            itemRefs[index].style.left = leftPosition;
          },
          onMouseleave: () => {
            isShowDeleteTips.value = false;
            currentEnter.value = -1;
          },
        };
      }
      return null;
    }

    function showConfirmModal(taskKey, articleStatus, lrcStatus) {
      deleteTaskKey.value = taskKey;
      if (articleStatus !== 1 || lrcStatus !== 1) {
        deleteTaskRef.value.toggleModal(true);
      } else {
        deleteNormalTaskRef.value.toggleModal(true);
      }
    }
    async function deleteTask() {
      const res = await deleteHearingTask({ taskKey: deleteTaskKey.value });
      if (res.code !== 0) {
        deleteTaskRef.value.toggleModal(false);
        deleteNormalTaskRef.value.toggleModal(false);
        message.error({ content: res.msg });
        return;
      }
      // 删除成功 刷新列表
      displayTaskList();
      deleteTaskRef.value.toggleModal(false);
      deleteNormalTaskRef.value.toggleModal(false);
    }
    function editTask(atcKey, clmKey, langType) {
      route.push({
        name: 'hearingDetail',
        query: {
          articleKey: atcKey,
          columnKey: clmKey,
          langType,
        },
      });
    }
    return {
      setItemRef,
      deleteIconRef,
      operationRef,
      itemRefs,
      containerRef,
      deleteTaskRef,
      deleteNormalTaskRef,
      deleteTaskKey,
      articleKey,
      columnKey,
      pendingNum,
      timer0,
      isShowDeleteTips,
      currentEnter,
      customRow,
      showConfirmModal,
      columns,
      dataTest,
      state,
      timeFormat,
      durationFormat,
      displayTaskList,
      deleteTask,
      editTask,
    };
  },
};
</script>

<style lang="scss">
.task-table {
  padding: 20px;
  min-width: 880px;
  .table-header {
    display: none;
    height: 56px;
    background: #f5f6f8;
    border-radius: 8px;
    padding: 0 20px;
  }
  .task-List-container {
    padding: 0 20px;
  }
  .task-blank {
    width: 200px;
    margin: 174px auto;
    .pic {
      width: 200px;
      height: 200px;
      background: url('../imgs/task_blank.png') no-repeat 0 0 / 200px 200px;
    }
    p {
      text-align: center;
      font-weight: 500;
      font-size: 17px;
      line-height: 20px;
      color: #898a8e;
    }
  }
  .showDeleteTips {
    position: absolute;
    z-index: 99;
    left: 50%;
    transform: translateX(-50%);
    transform: translateY(-10px);
    margin-bottom: 10px;
    width: 235px;
    height: 42px;
    font-size: 15px;
    line-height: 42px;
    text-align: center;
    color: #ffffff;
    background: rgba(0, 0, 0, 0.8);
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
  }
  .createTimeBox {
    min-width: 88px;
  }
  .status {
    min-width: 88px;
  }
  .pending {
    width: 66px;
    color: #3a89ff;
    font-weight: 500;
  }
  @keyframes pendingAnimation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .pendingLoading {
    display: inline-block;
    position: relative;
    width: 12px;
    height: 12px;
    left: 1px;
    top: -2px;
    animation: pendingAnimation 0.8s infinite linear;
  }
  .fulfilled {
    width: 66px;
    color: #09cd58;
    font-weight: 500;
    background: url('../imgs/fulfilled.png') no-repeat 42px -1px/ 24px 24px;
  }
  .fulfilled-mask {
    width: 66px;
    color: #09cd58;
    font-weight: 500;
    background: url('../imgs/fulfilled.png') no-repeat 42px -1px/ 24px 24px;
    opacity: 0.2;
  }
  .failed {
    color: #ff333a;
    font-weight: 500;
  }
  .operationBox {
    display: flex;
    justify-content: space-between;
  }
  .edit-disabled {
    width: 88px;
    text-align: center;
    color: #dfdfe0;
    font-weight: 500;
    padding: 8px 16px;
  }
  .edit {
    width: 88px;
    text-align: center;
    color: #3a89ff;
    font-weight: 500;
    padding: 8px 16px;
    background: rgba(58, 137, 255, 0.1);
    border-radius: 4px;
    cursor: pointer;
  }
  .delete {
    width: 88px;
    text-align: center;
    color: #ff333a;
    font-weight: 500;
    padding: 8px 16px;
    margin-left: 8px;
    background: rgba(255, 51, 58, 0.1);
    border-radius: 4px;
    cursor: pointer;
  }
  .ant-table {
    color: #212327;
  }
  .ant-table-thead > tr > th {
    padding: 17px 16px;
    font-weight: 500;
    text-align: left;
    background: #f5f6f8;
    border-bottom: 1px solid #f5f6f8;
  }
  .ant-table-tbody > tr > td {
    padding: 9px 16px;
    border-bottom: 1px solid #f5f6f8;
  }
  .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
    background: #fff;
  }

  .ant-table-thead > tr:first-child > th:first-child {
    border-radius: 8px 0 0 8px;
  }
  .ant-table-thead > tr:first-child > th:last-child {
    border-radius: 0 8px 8px 0;
  }
  .ant-table-tbody > tr:last-child > td {
    border-bottom: 1px solid #fff;
  }
}
</style>
